/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Billing_Bills_List_NextInputs */

const es_admin_billing_bills_list_next = /** @type {(inputs: Admin_Billing_Bills_List_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Siguiente`)
};

const en_admin_billing_bills_list_next = /** @type {(inputs: Admin_Billing_Bills_List_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Next`)
};

/**
* | output |
* | --- |
* | "Next" |
*
* @param {Admin_Billing_Bills_List_NextInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const admin_billing_bills_list_next = /** @type {((inputs?: Admin_Billing_Bills_List_NextInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Billing_Bills_List_NextInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_admin_billing_bills_list_next(inputs)
	return en_admin_billing_bills_list_next(inputs)
});
export { admin_billing_bills_list_next as "admin.billing.bills_list.next" }